import {
	Avatar,
	Box,
	Dialog,
	DialogContent,
	DialogTitle,
	Icon,
	Link,
	Typography,
	useTheme
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment-timezone'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link as RouterLink } from 'react-router-dom'
import { showError, showSuccess } from '../../../actions/misc/misc.actions'
import { getVisitById } from '../../../actions/visits/visits.actions'
import { api } from '../../../services/api'
import { getAvatarLetters } from '../../../services/helpers'
import DeleteConfirmation from '../DeleteConfirmation'
import { FACILITY_VISIT_RELATED_TRAINING, GROOMING } from '../../../utils'
import { errors, gray, purple } from '../../../utils/colors'

const useStyles = makeStyles((theme) => ({
	close: {
		position: 'absolute',
		color: gray[700],
		top: 10,
		right: 10,
		padding: 10,
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: 16,
		cursor: 'pointer'
	},
	descriptor: {
		fontSize: '1rem',
		fontWeight: '550',
		'& i': {
			fontSize: '20px',
			marginLeft: '17px',
			marginRight: '8px',
			color: purple[500],
			lineHeight: '20px'
		}
	},

	descriptors: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		flexWrap: 'wrap'
	},
	dialog: {
		'& .MuiDialog-paper': {
			width: 'auto',
			maxWidth: 1000,
			minWidth: 800
		}
	},
	groomingDialog: {
		'& .MuiDialog-paper': {
			width: 'auto',
			minWidth: 925,
			maxWidth: 1000
		}
	},
	dialogActions: {
		justifyContent: 'flex-start'
	},
	formWrapper: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 20
	},
	friend: {
		display: 'flex',
		flexDirection: 'row',
		margin: 10
	},
	friendAvatar: {
		height: '38px'
	},
	friendName: {
		fontSize: '1rem',
		fontWeight: '550',
		margin: '.5rem'
	},
	h6: {
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: 16,
		margin: 16
	},
	line: {
		height: 1,
		border: `1px solid ${gray[500]}`
	},
	noteBody: {
		margin: 14,
		fontSize: 14,
		width: 424
	},
	groomingNoteBody: {
		margin: 14,
		fontSize: 14
	},
	groomingNoteBody2: {
		margin: 14,
		fontSize: 14,
		width: 910
	},
	petRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		width: '100%',
		'& img': {
			height: 50,
			width: 50,
			borderRadius: 25,
			marginRight: 15
		},
		'& h4': {
			fontFamily: 'Nunito',
			fontWeight: '800',
			fontSize: 16,
			padding: 16
		}
	},
	reportHeader: {
		display: 'flex',
		justifyContent: 'space-between'
	},
	reportHeaderTitle: {
		textTransform: 'uppercase'
	},
	reportHeaderUnsent: {
		display: 'flex',
		alignItems: 'center',
		'& span': {
			fontSize: '13px',
			fontWeight: '800',
			marginRight: '5px',
			color: errors[500]
		},
		'& p': {
			color: errors[500],
			marginRight: '40px',
			fontFamily: 'Nunito',
			fontWeight: '800',
			fontSize: '1rem',
			lineHeight: '22px'
		}
	},
	reportPreview: {
		display: 'flex',
		flexDirection: 'row',
		paddingTop: 15
	},
	groomingReportPreview: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		paddingTop: 15
	},
	report: {
		display: 'flex',
		flexDirection: 'column'
	},
	groomingReport: {
		marginLeft: 12,
		width: 350,
		minHeight: 396,
		padding: 16,
		height: 'auto',
		borderRadius: '6px',
		background: gray[200],
		display: 'flex',
		flexDirection: 'column'
	},
	internalGroomingReport: {
		marginBottom: 12,
		width: '100%',
		minHeight: 80,
		height: 'auto',
		borderRadius: '6px',
		background: gray[200],
		display: 'flex',
		flexDirection: 'column'
	},
	reportItem: {
		minHeight: 100,
		height: 472,
		width: 500,
		background: gray[200],
		marginRight: 8,
		marginTop: 8,
		marginBottom: 8,
		borderRadius: '6px'
	},
	reportItemTraining: {
		minHeight: 100,
		width: '100%',
		background: gray[200],
		marginRight: 8,
		marginTop: 8,
		marginBottom: 8,
		borderRadius: '6px'
	},
	groomingColumn: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		alignItems: 'flex-start'
	},
	groomingReportPictures: {
		width: 500,
		marginBottom: 12,
		height: 'auto',
		borderRadius: '6px',
		background: gray[200],
		display: 'flex',
		flexDirection: 'column'
	},
	reportPictures: {
		marginLeft: 12,
		width: 350,
		minHeight: 396,
		height: 'auto',
		borderRadius: '6px',
		background: gray[200],
		display: 'flex',
		flexDirection: 'column'
	},
	pictureHolder: {
		flexDirection: 'row',
		justifyContent: 'flex-start',
		flexWrap: 'wrap',
		display: 'flex',
		margin: 12,
		marginTop: 0
	},
	picture: {
		width: 155,
		height: 155,
		margin: 4,
		border: `1px solid ${gray[500]}`,
		borderRadius: '10px'
	}
}))

const ReportDialog = ({ isShown, setIsShown, pet, visit, report, date }) => {
	const theme = useTheme()
	const classes = useStyles(theme)
	const client_descriptors = [
		{ name: 'Adventurous', icon: 'fa fa-backpack' },
		{ name: 'Affectionate', icon: 'fa fa-hand-heart' },
		{ name: 'Polite', icon: 'fa fa-hands-helping' },
		{ name: 'Good-Listener', icon: 'fa fa-headphones' },
		{ name: 'Generous', icon: 'fa fa-hand-holding-heart' },
		{ name: 'Patient', icon: 'fa fa-pause' },
		{ name: 'Lone Ranger', icon: 'fa fa-horse-saddle' },
		{ name: 'Energetic', icon: 'fa fa-bolt' },
		{ name: 'Chatty', icon: 'fa fa-volume-up' },
		{ name: 'Relaxed', icon: 'fa fa-snooze' },
		{ name: 'Brave', icon: 'fa fa-shield-alt' },
		{ name: 'Friendly', icon: 'fa fa-user-friends' },
		{ name: 'Playful', icon: 'fa fa-tennis-ball' },
		{ name: 'Cuddly', icon: 'fa fa-socks' },
		{ name: 'Active', icon: 'fa fa-rocket' }
	]

	const sentToday = report && moment().isSame(moment(report.timeSent), 'day')
	const [isDeleteOpen, setIsDeleteOpen] = useState(false)
	const dispatch = useDispatch()

	const isTrainingReport = report?.report_category === FACILITY_VISIT_RELATED_TRAINING

	const unsendReport = async () => {
		try {
			if (!report?._id) return
			let type = report?.type === GROOMING ? GROOMING : 'pc'
			if (isTrainingReport) {
				type = 'training'
			}

			let { data } = await api.patch(`/visit/unsendFacilityReport?type=${type}`, {
				facility_visit_report_id: report._id
			})
			if (data) {
				dispatch(showSuccess('The report was un-sent'))
				dispatch(getVisitById(visit._id))
				setIsShown(false)
			} else {
				dispatch(showError('An error occur, please try again'))
			}
		} catch (e) {
			console.log('error...', e)
			dispatch(showError('An error occur, please try again'))
		}
	}

	const renderPetTitle = (pet) => (
		<div className={classes.petTitle}>
			<Link
				component={RouterLink}
				to={`/clients/${visit.household_id}/pets/${pet._id}`}
				style={{ color: '#6B4AD6' }}>
				{pet.name}
			</Link>
		</div>
	)

	const renderDescriptors = (report) => {
		if (!report || !report.descriptions) return null

		let descriptors = report.descriptions

		return descriptors.map((descriptor) => {
			let icon = client_descriptors.find((d) => d.name === descriptor)?.icon || ''

			if (!icon) console.log(descriptor, 'wat')

			return (
				<Typography className={classes.descriptor}>
					<i className={icon ? icon : null} />
					{descriptor}
				</Typography>
			)
		})
	}

	const renderBestFriends = (report) => {
		if (!report || !report.friends) return null
		let friends = report.friends

		return friends.map((friend) => {
			return (
				<div className={classes.friend}>
					<Avatar
						className={classes.friendAvatar}
						alt={friend.name}
						src={friend.image_url ? friend.image_url : null}
					/>
					<Typography className={classes.friendName}> {friend.name}</Typography>
				</div>
			)
		})
	}

	const renderPictures = (images) => {
		if (!images) return null

		return images.map((image) => {
			return <img className={classes.picture} src={image.image_url} />
		})
	}

	const renderGroomingPictures = (type) => {
		const { before_photo_url, after_photo_url, reference_photos } = report
		const imgs = []
		if (type === 'before' && before_photo_url) imgs.push({ image_url: before_photo_url })
		if (type === 'after' && after_photo_url) imgs.push({ image_url: after_photo_url })
		if (type === 'reference' && reference_photos && reference_photos.length) {
			reference_photos.forEach((photo) => {
				imgs.push({ image_url: photo.image_url })
			})
		}
		return imgs.map((image, index) => {
			return <img key={`img-${index}`} className={classes.picture} src={image.image_url} />
		})
	}

	if (report?.type === 'grooming') {
		let { report_type } = report
		let reportSentString = ''
		if (report.grooming_report_sent) {
			reportSentString = ` - Sent at ${moment(report.grooming_report_sent_time).format('h:mm a')}`
		}

		if (report_type === 'client')
			return (
				<Dialog open={isShown} className={classes.groomingDialog} onClose={() => setIsShown(false)}>
					<Box className={classes.reportHeader}>
						<DialogTitle className={classes.reportHeaderTitle}>
							{report_type === 'internal'
								? 'Internal Grooming Report'
								: `Client Grooming Report - ${moment(report.startDate).format(
										'MMM D'
								  )}${reportSentString}`}
						</DialogTitle>
						{sentToday && (
							<Link
								className={classes.reportHeaderUnsent}
								underline="none"
								component="button"
								variant="body2"
								onClick={() => {
									setIsDeleteOpen(true)
								}}>
								<Icon className="fal fa-undo" />
								<Typography>Unsend Report</Typography>
							</Link>
						)}
					</Box>
					<DialogContent>
						<span className={classes.close} onClick={() => setIsShown(false)}>
							X
						</span>
						<div className={classes.formWrapper}>
							<div className={classes.petRow}>
								<Avatar
									alt={pet.name}
									src={
										pet.profile_image_file_name
											? `https://waggle-keys-prod.s3.amazonaws.com/${pet.profile_image_file_name}`
											: null
									}>
									{getAvatarLetters(pet.name)}
								</Avatar>
								<h4>{renderPetTitle(pet)}</h4>
							</div>
							<div className={classes.line} />
							<div className={classes.reportPreview}>
								<div className={classes.groomingColumn}>
									<div className={classes.groomingReportPictures}>
										<h6 className={classes.h6}>Before Photos </h6>
										<div className={classes.pictureHolder}>
											{renderGroomingPictures('before')}
										</div>
									</div>
									<div className={classes.groomingReportPictures}>
										<h6 className={classes.h6}>After Photos </h6>
										<div className={classes.pictureHolder}>
											{renderGroomingPictures('after')}
										</div>
									</div>
								</div>
								<div className={classes.groomingReport}>
									<h6 className={classes.h6}>Notes</h6>
									<Typography className={classes.groomingNoteBody}>
										{report?.grooming_client_report_notes || 'N/A'}
									</Typography>
								</div>
							</div>
						</div>
					</DialogContent>
					<DeleteConfirmation
						isShown={isDeleteOpen}
						setIsShown={setIsDeleteOpen}
						onConfirmDelete={() => {
							unsendReport()
							setIsDeleteOpen(false)
						}}
						// isDeleteLoading={isDeleteLoading}
						title="Unsend report"
						body="Are you sure you want to unsend this client report? This will revert the status back to ‘Ready.’"
						confirmButtonText="Confirm"
					/>
				</Dialog>
			)

		return (
			<Dialog open={isShown} className={classes.groomingDialog} onClose={() => setIsShown(false)}>
				<Box className={classes.reportHeader}>
					<DialogTitle className={classes.reportHeaderTitle}>Internal Grooming Report</DialogTitle>
				</Box>
				<DialogContent>
					<span className={classes.close} onClick={() => setIsShown(false)}>
						X
					</span>
					<div className={classes.formWrapper}>
						<div className={classes.petRow}>
							<Avatar
								alt={pet.name}
								src={
									pet.profile_image_file_name
										? `https://waggle-keys-prod.s3.amazonaws.com/${pet.profile_image_file_name}`
										: null
								}>
								{getAvatarLetters(pet.name)}
							</Avatar>
							<h4>{renderPetTitle(pet)}</h4>
						</div>
						<div className={classes.line} />
						<div className={classes.groomingReportPreview}>
							<div className={classes.internalGroomingReport}>
								<h6 className={classes.h6}>Service Notes</h6>
								<Typography className={classes.groomingNoteBody2}>
									{report?.grooming_team_report_notes || 'N/A'}
								</Typography>
							</div>
							<div className={classes.internalGroomingReport}>
								<h6 className={classes.h6}>Behavior Notes</h6>
								<Typography className={classes.groomingNoteBody2}>
									{report?.behavior_notes || 'N/A'}
								</Typography>
							</div>
							<div className={classes.internalGroomingReport}>
								<h6 className={classes.h6}>Reference Photos </h6>
								<div className={classes.pictureHolder}>{renderGroomingPictures('reference')}</div>
							</div>
						</div>
					</div>
				</DialogContent>
				<DeleteConfirmation
					isShown={isDeleteOpen}
					setIsShown={setIsDeleteOpen}
					onConfirmDelete={() => {
						unsendReport()
						setIsDeleteOpen(false)
					}}
					// isDeleteLoading={isDeleteLoading}
					title="Unsend report"
					body="Are you sure you want to unsend this client report? This will revert the status back to ‘Ready.’"
					confirmButtonText="Confirm"
				/>
			</Dialog>
		)
	}

	return (
		<Dialog open={isShown} className={classes.dialog} onClose={() => setIsShown(false)}>
			<Box className={classes.reportHeader}>
				<DialogTitle className={classes.reportHeaderTitle}>
					{!report ? null : report.time} CLIENT REPORT - {date.split(',')[0]} - Sent At{' '}
					{!report ? null : moment.tz(report.timeSent, 'America/New_York').format('hh:mmA z')}
				</DialogTitle>
				{sentToday && (
					<Link
						className={classes.reportHeaderUnsent}
						underline="none"
						component="button"
						variant="body2"
						onClick={() => {
							setIsDeleteOpen(true)
						}}>
						<Icon className="fal fa-undo" />
						<Typography>Unsend Report</Typography>
					</Link>
				)}
			</Box>
			<DialogContent>
				<span className={classes.close} onClick={() => setIsShown(false)}>
					X
				</span>
				<div className={classes.formWrapper}>
					<div className={classes.petRow}>
						<Avatar
							alt={pet.name}
							src={
								pet.profile_image_file_name
									? `https://waggle-keys-prod.s3.amazonaws.com/${pet.profile_image_file_name}`
									: null
							}>
							{getAvatarLetters(pet.name)}
						</Avatar>
						<h4>{renderPetTitle(pet)}</h4>
					</div>
					<div className={classes.line} />
					{isTrainingReport ? (
						<div className={classes.reportPreview}>
							<div className={classes.report}>
								<div className={classes.reportItemTraining}>
									<h6 className={classes.h6}>Today I learned...</h6>
									<div className={classes.descriptors}>
										{report?.training_skills_primary?.map((skill) => {
											return (
												<Typography className={classes.descriptor}>
													<i class="fas fa-puzzle-piece"></i>
													{skill.name}
												</Typography>
											)
										})}
									</div>
								</div>
								<div className={classes.reportItemTraining}>
									<h6 className={classes.h6}>We also reviewed...</h6>
									<div className={classes.descriptors}>
										{report?.training_skills_secondary?.map((skill) => {
											return (
												<Typography className={classes.descriptor}>
													<i class="fas fa-puzzle-piece"></i>
													{skill.name}
												</Typography>
											)
										})}
									</div>
								</div>
								<div className={classes.reportItemTraining}>
									<h6 className={classes.h6}>My temperament was...</h6>
									<div className={classes.descriptors}>
										{report?.training_temperaments?.map((temp = '') => {
											let formatted = temp.split('_')
											formatted = formatted.map((word) => {
												const firstLetter = word.substring(0, 1)
												return `${firstLetter.toUpperCase()}${word.substring(1)}`
											})
											return (
												<Typography className={classes.descriptor}>
													<i class="fas fa-brain"></i>
													{formatted.join(' ')}
												</Typography>
											)
										})}
									</div>
								</div>
								<div className={classes.reportItemTraining}>
									<h6 className={classes.h6}>Notes</h6>
									<Typography className={classes.noteBody}>
										{report ? report.notes : null}
									</Typography>
								</div>
								<div className={classes.reportItemTraining}>
									<h6 className={classes.h6}>Videos</h6>
									<div className={classes.pictureHolder}>
										{report?.videos?.map((video) => {
											const skill =
												report?.training_skills_primary?.find(
													(s) => s._id === video.training_skill_id
												) || null
											return (
												<div>
													{skill ? <h4>{skill.name}</h4> : null}
													<video controls src={video.url} />
													{video?.notes ? (
														<Typography className={classes.noteBody}>
															{video.notes}
														</Typography>
													) : null}
												</div>
											)
										})}
									</div>
								</div>
							</div>
						</div>
					) : (
						<div className={classes.reportPreview}>
							<div className={classes.report}>
								<div className={classes.reportItem}>
									<h6 className={classes.h6}> Today I was </h6>
									<div className={classes.descriptors}>
										{renderDescriptors(report ? report : null)}
									</div>
								</div>
								<div className={classes.reportItem}>
									<h6 className={classes.h6}> My best friends were ... </h6>
									<div className={classes.descriptors}>
										{renderBestFriends(report ? report : null)}
									</div>
								</div>
								<div className={classes.reportItem}>
									<h6 className={classes.h6}>Notes</h6>
									<Typography className={classes.noteBody}>
										{' '}
										{report ? report.notes : null}{' '}
									</Typography>
								</div>
							</div>
							<div className={classes.reportPictures}>
								<h6 className={classes.h6}> Photos </h6>
								<div className={classes.pictureHolder}>
									{renderPictures(report ? report.images : null)}
								</div>
							</div>
						</div>
					)}
				</div>
			</DialogContent>
			<DeleteConfirmation
				isShown={isDeleteOpen}
				setIsShown={setIsDeleteOpen}
				onConfirmDelete={() => {
					unsendReport()
					setIsDeleteOpen(false)
				}}
				// isDeleteLoading={isDeleteLoading}
				title="Unsend report"
				body="Are you sure you want to unsend this client report? This will revert the status back to ‘Ready.’"
				confirmButtonText="Confirm"
			/>
		</Dialog>
	)
}

export default ReportDialog
